import { FunctionComponent, memo } from "react";
import { IProps } from "./delete-phrase-trigger-action.types";
import { Button } from "@edgetier/components";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import { axios } from "utilities/axios";
import { IPhraseTrigger, Route } from "@edgetier/watchtower-types";
import { useQueryClient } from "react-query";
import "./delete-phrase-trigger-action.scss";

/**
 * A menu action that, when clicked, will open a modal asking the user to confirm that they want to delete the phrase
 * trigger. When they confirm, a request is sent to the backend for the phrase trigger to be deleted.
 * @param props.phraseTriggerId The ID of the phrase trigger being deleted.
 * @param props.closeModal      Callback for closeing the modal
 */
const DeletePhraseTriggerAction: FunctionComponent<IProps> = ({ phraseTriggerId, closeModal }) => {
    const queryClient = useQueryClient();

    /**
     * Send a DELETE request to the backend to delete phrase trigger.
     */
    const deletePhraseTrigger = async () => {
        try {
            await axios.delete(Route.PhraseTrigger.replace(":phraseTriggerId", phraseTriggerId));
            queryClient.setQueriesData<IPhraseTrigger[]>(Route.PhraseTriggers, (phraseTriggers) => {
                return (phraseTriggers ?? []).filter(
                    (phraseTrigger) => phraseTrigger.phraseTriggerId !== phraseTriggerId
                );
            });
            toast.success("Successfully deleted phrase trigger.");

            closeModal();
        } catch (error) {
            toast.error("Failed to delete phrase trigger.");
        }
    };

    return (
        <div>
            <div className="phrase-trigger-remove-action">
                <p>Are you sure you want to delete this phrase trigger? This cannot be undone.</p>
            </div>
            <div className="phrase-trigger-remove-action__buttons">
                <Button id="delete-phrase-trigger" styleName="negative" onClick={deletePhraseTrigger} icon={faTrash}>
                    Delete
                </Button>
            </div>
        </div>
    );
};

export default memo(DeletePhraseTriggerAction);
